export default __webpack_public_path__ + "static/media/treatment.4663af19.png";